import { IPostViewModel } from 'viewModels';
import api from '../services/api/axios';

const insert = async (input: FormData) =>
  new Promise<string>((resolve, reject) => {
    api
      .post(`post`, input, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(({ data }) => resolve(data))
      .catch(() => reject());
  });

const getPosts = async () =>
  new Promise<IPostViewModel[]>((resolve, reject) => {
    api
      .get(`post`)
      .then(({ data }) => resolve(data))
      .catch(() => reject());
  });

export const PostController = {
  insert,
  getPosts,
};
